var PrescriptionSide = /* @__PURE__ */ ((PrescriptionSide2) => {
  PrescriptionSide2["Right"] = "rightEye";
  PrescriptionSide2["Left"] = "leftEye";
  return PrescriptionSide2;
})(PrescriptionSide || {});
var PrescriptionKey = /* @__PURE__ */ ((PrescriptionKey2) => {
  PrescriptionKey2["Power"] = "power";
  PrescriptionKey2["Axis"] = "axis";
  PrescriptionKey2["Cylinder"] = "cylinder";
  PrescriptionKey2["Addition"] = "addition";
  PrescriptionKey2["BaseCurve"] = "baseCurve";
  PrescriptionKey2["Diameter"] = "diameter";
  PrescriptionKey2["PupillaryDistance"] = "pupillaryDistance";
  PrescriptionKey2["Prism"] = "prism";
  PrescriptionKey2["Dominance"] = "dominance";
  return PrescriptionKey2;
})(PrescriptionKey || {});
var Validity = /* @__PURE__ */ ((Validity2) => {
  Validity2[Validity2["VALID"] = 1] = "VALID";
  Validity2[Validity2["INVALID"] = 0] = "INVALID";
  return Validity2;
})(Validity || {});
var PrescriptionType = /* @__PURE__ */ ((PrescriptionType2) => {
  PrescriptionType2["EXISTING_CUSTOMER"] = "ExistingCustomer";
  PrescriptionType2["NEW_PRESCRIPTION"] = "NewPrescription";
  PrescriptionType2["PRESCRIPTION_FILE"] = "PrescriptionFile";
  PrescriptionType2["EMAIL_PRESCRIPTION"] = "EmailPrescription";
  PrescriptionType2["OCR_PRESCRIPTION"] = "OCRPrescription";
  PrescriptionType2["PRESCRIPTION_WITH_MANUAL_XOR_FILE_PUPILLARY_DISTANCE"] = "PrescriptionWithManualXORFilePupillaryDistance";
  return PrescriptionType2;
})(PrescriptionType || {});
export {
  PrescriptionKey,
  PrescriptionSide,
  PrescriptionType,
  Validity
};
//# sourceMappingURL=prescription.js.map
